import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import axiosAuth from '@/axios-auth';
import axios from 'axios';
import fs, { Stats } from 'fs';
import _ from 'lodash'; //Para ordenamiento de arreglos.
import { push } from 'core-js/fn/array';
// import path from 'path';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        version: '1.0.2',
        appTitle: 'Inteligencia Ejecutiva',
        mainLogo: require('@/assets/tw.png'),
        mainLogoAppBar: require('@/assets/tw_app_bar.png'),
        inteligenciaEjecutivaLogo: require('@/assets/inteligenciaejecutiva.png'),
        inteligenciaEjecutivaLogo1: require('@/assets/inteligenciaejecutiva1.png'),
        mainBackgroundImg: '../assets/floriane-vita-FyD3OWBuXnY-unsplash.jpg',
        bWaitCursor: false,
        bFailedLogin: false,
        isAuthenticated: false,
        bInactiveUser: false,
        userName: '', //Nombre del usuario logueado.
        bAdmin: false,
        //authHeader: null,
        idToken: null,
        userID: null,
        //userType: 0, //1 = superadmin, 2 = admin. prepago, 3 = admin. de seguimiento, 4 = encuestado.

        user: null,
        users: null,
        administrators: null,

        bDuplicatedUserError: false, //Indica que hay que desplegar un mensaje de error ya que se intentó registrar a un usuario con un correo previamente registrado.

        userTypes: [],
        selectedUserTypeIndex: -1,

        selectedAnswerSetIndex: -1,
        bSearchNewAnswerSet: false,
        newAnswerSetName: '',

        answers: [],
        languageAnswers: [],
        answerTable: [],

        questionnaires: [],
        selectedQuestionnaireIndex: -1,
        bSearchNewQuestionnaire: false, //Indica a Questionnaires.vue que debe buscar la información de un nuevo cuestionario (mediante un watch).
        newQuestionnaireID: 0,

        questionnaireLanguages: [],
        questionnaireIntros: [],
        questionnaireIntroTable: [],
        questionnaireSituations: [],
        questionnaireSituationsLang: [],
        questionnaireSituationTable: [],
        questionnaireAnswers: [],
        questionnaireAnswersLang: [],
        questionnaireAnswerTable: [],
        questionnaireAnswerHeader: [],
        questionnaireAutoevaluations: [],
        questionnaireAutoevaluationsLang: [],
        questionnaireAutoevaluationTable: [],
        questionnaireTablesHeader: [], //Header de las tablas del cuestionario, para la ventana Questionnaires.vue.

        bQuestionnaireNotDeletedWarning: false,
        bServerResponse: false, //Indica si el servidor ya respondió ante un request de borrado de cuestionario.
        surveys: [],
        selectedSurveyIndex: -1,
        bSearchNewSurvey: false, //Indica a Surveys.vue que debe buscar la información de una nueva encuesta (mediante un watch).
        survey: null, //Encuesta seleccionada en la ventana Encuestas.
        //surveyUsers: [],

        bSurveyLoaded: false, //Indica si ya se recibió la información de una encuesta seleccionada, para después poder obtener la información relacionada.
        bLoadingSurvey: false, //Indica si la información de una encuesta está siendo cargada, para no dejar cambiarse a ninguna otra encuesta antes de que se reciba toda la información.
        //Si no, se pueden mezclar los usuarios si se cambia de encuesta antes de terminarse de bajar los usuarios de una encuesta.

        bReportProcessed: false, //Indica que el servidor ya mandó el reporte procesado.
        iReportWarning: 0, //Indica la causa por la que no se generó el reporte.
        pdfPath: '',

        bQuestionnaireLoaded: false, //Indica si ya se recibió la información de un caso seleccionado, para después poder obtener la información relacionada.
        bLoadingQuestionnaire: false, //Indica si la información del caso está siendo cargado, para no dejar cambiarse a ningún otro caso antes de que se reciba toda la información.

        userSurveys: [], //Encuestas del usuario encuestado logueado.
        userSurvey: null, //Encuesta seleccionada por el usuario encuestado logueado.
        userSurveyLangID: 0, //Idioma seleccionado por el usuario para contestar una encuesta.
        userSurveyData: null, //Información de la encuesta a contestar por el usuario.
        surveyResults: null,

        bSearchNewUser: false, //Indica si se debe buscar el índice del usuario que se acaba de registrar.
        newUserEmail: '', //Indica el email de un nuevo usuario registrado, para poder seleccionarlo después en la ventana Usuarios.
        selectedUserIndex: -1, //Indice del usuario seleccionado en la ventana Usuarios.

        languages: [],
        selectedLanguageIndex: -1, //Indice del idioma seleccionado en la ventana Idiomas.
        bSearchNewLanguage: false, //Indica si se debe buscar el índice del idioma que se acaba de registrar.
        newLanguageName: '', //Indica el nombre de un nuevo idioma registrado, para poder seleccionarlo después en la ventana Idiomas.

        genders: [],
        organizationalLevels: [],
        ageRanges: [],

        roles: [],
        rolesExt: [], //Arreglo que incluye el nombre personalizado para cada usuario.
        userRoles: [], //Roles asignados a un usuario.
        originalUserRoles: [], //Arreglo para poder comparar los cambios que se hagan.
        userRolesToSave: [], //Arreglo para actualizar la base de datos.
        selectedRoleIndex: -1,
        bSearchNewRole: false,
        newRoleName: '',

        /********************************************** */

        bErrorNoLang: false, //Indica que no hay cuestionarios en el idioma seleccionado al comenzar una nueva encuesta.
        bSurveyResultsError: false //Indica que hubo algún error al procesar los resutados de una encuesta nueva.
    },

    mutations: {
        setFailedLogin(state, payload) {
            state.bFailedLogin = payload;
        },
        setInactiveUser(state, payload) {
            state.bInactiveUser = payload;
        },
        authUser(state, userData) {
            //state.authHeader = userData.authHeader;
            state.idToken = userData.idToken;
            state.userID = userData.userID;
        },
        clearAuthData(state) {
            //state.authHeader = null,
            console.log('clearAuthData...');

            state.idToken = null;
            state.userID = null;
            state.isAuthenticated = false;
        },
        setDuplicatedUserError(state, payload) {
            state.bDuplicatedUserError = payload;
        },
        setIsAuthenticated(state, payload) {
            state.isAuthenticated = payload;
        },
        setUser(state, user) {
            state.user = user;
            state.userName = user.nombre + ' ' + user.appaterno + ' ' + user.apmaterno;

            if (state.user.tipoid === 1) {
                //Super administrador
                state.bAdmin = true;
            } //Usuario encuestador
            else {
                state.bAdmin = false;
            }
        },

        setUserTypes(state, userTypes) {
            state.bWaitCursor = true;
            state.userTypes = userTypes;
            state.bWaitCursor = false;
        },

        setAnswers(state, answers) {
            state.bWaitCursor = true;
            state.answers = answers;
            state.bWaitCursor = false;
        },

        setLanguageAnswers(state, languageAnswers) {
            state.bWaitCursor = true;
            state.languageAnswers = languageAnswers;
            state.bWaitCursor = false;
        },

        setSelectedAnswerSetIndex: (state, index) => {
            state.selectedAnswerSetIndex = index;
        },

        setAnswerTable(state, answerTable) {
            state.answerTable = answerTable;
        },

        setAnswerTableHeader(state, answerHeader) {
            state.answerTableHeader = answerHeader;
        },

        setLanguagesAnswerSet(state, languagesAnswerSet) {
            state.languagesAnswerSet = languagesAnswerSet;
        },

        setQuestionnaires(state, questionnaires) {
            state.bWaitCursor = true;
            state.questionnaires = questionnaires;

            if (state.newQuestionnaireID !== 0) {
                var i;
                for (i = 0; i < questionnaires.length; i++) {
                    if (state.newQuestionnaireID === questionnaires[i].id) {
                        state.selectedQuestionnaireIndex = i;
                        state.bSearchNewQuestionnaire = true;
                    }
                }
            }
            state.bWaitCursor = false;
        },

        setSelectedQuestionnaireIndex: (state, index) => {
            state.selectedQuestionnaireIndex = index;
        },

        setSearchNewQuestionnaire: (state, search) => {
            state.bSearchNewQuestionnaire = search;
        },

        setNewQuestionnaireID: (state, id) => {
            state.newQuestionnaireID = id;
        },

        setQuestionnaireLanguages(state, questionnaireLanguages) {
            state.bWaitCursor = true;
            state.questionnaireLanguages = questionnaireLanguages;
            state.bWaitCursor = false;
        },

        setQuestionnaireIntros(state, questionnaireIntros) {
            state.bWaitCursor = true;
            state.questionnaireIntros = questionnaireIntros;
            state.bWaitCursor = false;
        },

        setQuestionnaireIntroTable(state, questionnaireIntroTable) {
            state.bWaitCursor = true;
            state.questionnaireIntroTable = questionnaireIntroTable;
            state.bWaitCursor = false;
        },

        setQuestionnaireTablesHeader(state, questionnaireHeader) {
            state.questionnaireTablesHeader = questionnaireHeader;
        },

        setQuestionnaireAnswerHeader(state, questionHeader) {
            state.questionnaireAnswerHeader = questionHeader;
        },

        setQuestionnaireSituations(state, questionnaireSituations) {
            state.bWaitCursor = true;
            state.questionnaireSituations = questionnaireSituations;
            state.bWaitCursor = false;
        },

        setQuestionnaireSituationsLang(state, questionnaireSituationsLang) {
            state.bWaitCursor = true;
            state.questionnaireSituationsLang = questionnaireSituationsLang;
            state.bWaitCursor = false;
        },

        setQuestionnaireAnswers(state, questionnaireAnswers) {
            state.bWaitCursor = true;
            state.questionnaireAnswers = questionnaireAnswers;
            state.bWaitCursor = false;
        },

        setQuestionnaireAnswersLang(state, questionnaireAnswersLang) {
            state.bWaitCursor = true;
            state.questionnaireAnswersLang = questionnaireAnswersLang;
            state.bWaitCursor = false;
        },

        setQuestionnaireAutoevaluations(state, questionnaireAutoevaluations) {
            state.bWaitCursor = true;
            state.questionnaireAutoevaluations = questionnaireAutoevaluations;
            state.bWaitCursor = false;
        },

        setQuestionnaireAutoevaluationsLang(state, questionnaireAutoevaluationsLang) {
            state.bWaitCursor = true;
            state.questionnaireAutoevaluationsLang = questionnaireAutoevaluationsLang;
            state.bWaitCursor = false;
        },

        setQuestionnaireSituationTable(state, questionnaireSituationTable) {
            state.bWaitCursor = true;
            state.questionnaireSituationTable = questionnaireSituationTable;
            state.bWaitCursor = false;
        },

        setQuestionnaireAnswerTable(state, questionnaireAnswerTable) {
            state.bWaitCursor = true;
            state.questionnaireAnswerTable = questionnaireAnswerTable;
            state.bWaitCursor = false;
        },

        setQuestionnaireAutoevaluationTable(state, questionnaireAutoevaluationTable) {
            state.bWaitCursor = true;
            state.questionnaireAutoevaluationTable = questionnaireAutoevaluationTable;
            state.bWaitCursor = false;
        },

        setQuestionnaireNotDeletedWarning(state, bWarning) {
            state.bQuestionnaireNotDeletedWarning = bWarning;
        },

        setServerResponse(state, bResponse) {
            state.bServerResponse = bResponse;
        },

        setSurveys(state, surveys) {
            state.bWaitCursor = true;
            state.surveys = surveys;
            state.bWaitCursor = false;
            console.log('state.surveys = ', state.surveys);
        },

        setSelectedSurveyIndex: (state, index) => {
            state.selectedSurveyIndex = index;
        },

        setSearchNewSurvey: (state, search) => {
            state.bSearchNewSurvey = search;
        },

        initQuestionnaireData(state) {
            state.questionnaireLanguages = [];
            state.questionnaireIntros = [];
            state.questionnaireIntroTable = [];
            state.questionnaireSituations = [];
            state.questionnaireSituationsLang = [];
            state.questionnaireSituationTable = [];
            state.questionnaireAnswers = [];
            state.questionnaireAnswersLang = [];
            state.questionnaireAnswerTable = [];
            state.questionnaireAnswerHeader = [];
            state.questionnaireAutoevaluations = [];
            state.questionnaireAutoevaluationsLang = [];
            state.questionnaireAutoevaluationTable = [];
            state.questionnaireTablesHeader = [];
        },

        // initSurveyData(state) {
        //     //Inicializa el modelo de una encuesta, antes de desplegar la ventana Encuestas.

        //     //console.log("initSurveyData...");
        //     state.survey = {
        //         encuestaID: 0,
        //         usuarioID: 0, //usuario logueado cuando se crea la encuesta
        //         adminSegInternoID: 0, //Select, todos los usuarios que son admin. de seg. interno de la compañía seleccionada, es opcional.
        //         envioMailReporte: '0', //0 = Sólo al usuario, 1 = al administrador de seguimiento interno, 2 a ambos, 3 a ninguno
        //         nombreEncuesta: '',
        //         evaluado: '',
        //         invitacionMandada: false,
        //         fechaRegistro: '',
        //         fechaInicio: '',
        //         fechaCierre: '',
        //         empresaID: 0,
        //         numRespuestas: 0,
        //         cuestionarioID: 0,
        //         idiomas: [],
        //         google360: false,
        //         mandarEstados: false,
        //         mandarEstadosDias: 0,
        //         mandarRecordatorios: false,
        //         mandarRecordatoriosDias: 0,
        //         textoInvitacion: '',
        //         alias: {
        //             autoretroalimentado: '',
        //             jefeDirecto: '',
        //             jefeFuncional: '',
        //             colega: '',
        //             cliente: '',
        //             colaborador: ''
        //         },
        //         usuarios: [],
        //         modulos: []
        //     };
        // },

        setSurveyData(state, survey) {
            state.survey = survey;
        },

        setSurveyLoaded(state, bLoaded) {
            state.bSurveyLoaded = bLoaded;
        },

        setLoadingSurvey(state, bLoading) {
            state.bLoadingSurvey = bLoading;
        },

        setQuestionnaireLoaded(state, bLoaded) {
            state.bQuestionnaireLoaded = bLoaded;
        },

        setLoadingQuestionnaire(state, bLoading) {
            state.bLoadingQuestionnaire = bLoading;
        },

        setUserSurveys(state, surveys) {
            state.userSurveys = surveys;
        },

        setUserSurvey(state, survey) {
            state.userSurvey = survey;
        },

        setUserSurveyLanguage(state, languageID) {
            state.userSurveyLangID = languageID;
        },

        setUserSurveyData(state, surveyData) {
            state.userSurveyData = surveyData;
        },

        setUserSurveyResults(state, surveyResults) {
            state.surveyResults = surveyResults;
        },

        setLanguages(state, languages) {
            state.bWaitCursor = true;
            state.languages = languages;

            if (state.bSearchNewLanguage) {
                var i;
                for (i = 0; i < languages.length; i++) {
                    if (state.newLanguageName === languages[i].idioma) {
                        state.selectedLanguageIndex = i;
                        state.bSearchNewLanguage = false;
                        state.newLanguageName = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },

        updateSelectedLanguageIndex: (state, index) => {
            state.selectedLanguageIndex = index;
        },

        setGenders(state, genders) {
            state.bWaitCursor = true;
            state.genders = genders;
            state.bWaitCursor = false;
        },

        setOrganizationalLevels(state, levels) {
            state.bWaitCursor = true;
            state.organizationalLevels = levels;
            state.bWaitCursor = false;
        },

        setAgeRanges(state, ranges) {
            state.bWaitCursor = true;
            state.ageRanges = ranges;
            state.bWaitCursor = false;
        },

        setUsers(state, users) {
            if (state.users !== null) {
                state.users.length = 0;
            }

            state.bWaitCursor = true;
            state.users = users;

            var i;
            for (i = 0; i < users.length; i++) {
                // const user = {
                //     name: users[i].apaterno + " " + users[i].amaterno + " " + users[i].nombre,
                //     id: users[i].usuariosid
                // };

                if (state.bSearchNewUser) {
                    if (state.newUserEmail === users[i].email) {
                        //console.log("Nuevo usuario identificado, ", users[i].email);
                        state.selectedUserIndex = i;
                        state.bSearchNewUser = false;
                        state.newUserEmail = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },
        setAdministrators(state, users) {
            if (state.administrators !== null) {
                state.administrators.length = 0;
            }

            state.bWaitCursor = true;
            state.administrators = users;

            var i;
            for (i = 0; i < users.length; i++) {
                // const user = {
                //     name: users[i].apaterno + " " + users[i].amaterno + " " + users[i].nombre,
                //     id: users[i].usuariosid
                // };

                if (state.bSearchNewUser) {
                    if (state.newUserEmail === users[i].correo) {
                        //console.log("Nuevo usuario identificado, ", users[i].email);
                        state.selectedUserIndex = i;
                        state.bSearchNewUser = false;
                        state.newUserEmail = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },
        addNewUser(state, newUser) {
            state.users.push(newUser);
        },
        addNewAdministrator(state, newUser) {
            state.administrators.push(newUser);
        },
        updateSelectedUserIndex: (state, index) => {
            state.selectedUserIndex = index;
        },

        //*Funciones ********************************************************************/

        updateSelectedPrimaryIndex: (state, index) => {
            state.selectedPrimaryIndex = index;
        },
        updateSelectedSpecializedIndex: (state, index) => {
            state.selectedSpecializedIndex = index;
        },

        updateSelectedPrimaryValIndex: (state, index) => {
            state.selectedPrimaryValIndex = index;
        },
        updateSelectedSpecializedValIndex: (state, index) => {
            state.selectedSpecializedValIndex = index;
        },

        //*Roles ********************************************************************/
        setRoles(state, roles) {
            state.bWaitCursor = true;
            state.roles = roles;

            if (state.bSearchNewRole) {
                var i;
                for (i = 0; i < roles.length; i++) {
                    if (state.newRoleName === roles[i].rol) {
                        state.selectedRoleIndex = i;
                        state.bSearchNewRole = false;
                        state.newRoleName = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },
        setRolesExtended(state, roles) {
            state.bWaitCursor = true;
            state.rolesExt = roles;
            state.bWaitCursor = false;
        },
        updateSelectedRoleIndex: (state, index) => {
            state.selectedRoleIndex = index;
        },
        initUserRoles(state, { userID, roles }) {
            //console.log("initUserRoles()");

            state.bWaitCursor = true;
            //state.userRoles = roles;

            //Agrega a state.roles el campo para el nombre personalizado:
            state.rolesExt = [];
            //var userID = roles[0].usuariosid; //Se obtiene el ID del usuario.
            var i;
            for (i = 0; i < state.roles.length; i++) {
                const rol = {
                    rolesid: state.roles[i].rolesid,
                    rol: state.roles[i].rol,
                    talento: state.roles[i].talento,
                    contribucion: state.roles[i].contribucion,
                    total: state.roles[i].total,
                    tamanoaplicacion: state.roles[i].tamanoaplicacion + '%',
                    factor1: state.roles[i].factor1,
                    factor2: state.roles[i].factor2,
                    nombre: state.roles[i].rol, //Se repite el nombre. Si está en userRoles se sobreescribe con el valor de ahí.
                    usuariosid: userID,
                    usuariosrolesid: 0 //Se llena más adelante.
                };
                state.rolesExt.push(rol);
            }

            //console.log("En inittUserRoles, roles = ", roles);

            //Crea el arreglo userRoles agregándole todos los campos del arreglo roles:

            state.userRoles = [];

            for (i = 0; i < roles.length; i++) {
                var j;
                for (j = 0; j < state.rolesExt.length; j++) {
                    if (roles[i].rolesid === state.rolesExt[j].rolesid) {
                        const rol = {
                            rolesid: state.rolesExt[j].rolesid,
                            rol: state.rolesExt[j].rol,
                            talento: state.rolesExt[j].talento,
                            contribucion: state.rolesExt[j].contribucion,
                            total: state.rolesExt[j].total,
                            tamanoaplicacion: state.rolesExt[j].tamanoaplicacion,
                            factor1: state.rolesExt[j].factor1,
                            factor2: state.rolesExt[j].factor2,
                            nombre: roles[i].nombre, //nombre personalizado
                            usuariosid: roles[i].usuariosid,
                            usuariosrolesid: roles[i].usuariosrolesid
                        };
                        state.userRoles.push(rol);

                        //Pone el nombre personalizado en el arreglo de todos los roles, en los registros que coinciden con los del
                        //arreglo de roles del usuario:
                        state.rolesExt[j].nombre = roles[i].nombre;
                        state.rolesExt[j].usuariosrolesid = roles[i].usuariosrolesid;
                        break;
                    }
                }
            }
            //console.log("userRoles = ", state.userRoles);
            //console.log("rolesExt = ", state.rolesExt);
            state.originalUserRoles = JSON.parse(JSON.stringify(state.userRoles));

            state.bWaitCursor = false;
        },
        setUserRoles(state, roles) {
            state.userRoles = roles;
        },
        restoreUserRoles(state) {
            state.userRoles = JSON.parse(JSON.stringify(state.originalUserRoles));
        },

        setReportProcessed(state, payload) {
            state.bReportProcessed = payload;
        },
        setReportWarning(state, payload) {
            state.iReportWarning = payload;
        },
        setPdfPath(state, strPath) {
            state.pdfPath = strPath;
        },

        setErrorNoLang(state, payload) {
            state.bErrorNoLang = payload;
        },
        setSurveyResultsError(state, payload) {
            state.bSurveyResultsError = payload;
        }
    },
    actions: {
        login({ commit, dispatch, state }, authData) {
            state.bWaitCursor = true;

            //Autenticación en Jocoque:
            axiosAuth
                .post('/usuarios/login/', null, {
                    params: {
                        user: authData.email,
                        password: authData.password
                    }
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Autenticación OK, res = ', res);

                    var user = res.data;
                    if (user.error === 0) {
                        var idToken = user.token.slice(7);

                        //axios.defaults.headers.common['Authorization'] = user.token;

                        commit('authUser', {
                            //authHeader: user.token,
                            idToken: idToken,
                            userID: user.usuarioid
                        });

                        //console.log("state.idToken = ", state.idToken);
                        //console.log("state.authData = ", state.authHeader);

                        commit('setIsAuthenticated', true);
                        commit('setUser', user);

                        //Carga todas las tablas de configuración:
                        dispatch('fetchAdminConfigData');

                        const now = new Date();
                        const expirationDate = new Date(now.getTime() + res.data.expiresin * 1000); //Con getTime() se obtiene el tiempo en milisegundos
                        console.log('ExpirationDate = ', expirationDate);

                        //localStorage.setItem('authHeader', res.data.token)
                        //localStorage.setItem('token', res.data.idToken);
                        localStorage.setItem('token', idToken);
                        localStorage.setItem('userID', res.data.localId);
                        localStorage.setItem('expirationDate', expirationDate);
                        localStorage.setItem('userEmail', res.data.email);
                        dispatch('setLogoutTimer', res.data.expiresin);

                        state.bWaitCursor = false;
                        //router.push('/');
                        router.push('/').catch(err => {});
                    } else if (user.error === 3) {
                        //Usuario Inactivo...
                        state.bWaitCursor = false;
                        commit('setIsAuthenticated', false);
                        commit('setInactiveUser', true);
                    } //Error en nombre de usuario o password...
                    else {
                        console.log('Error de autenticación #', user.error);
                        state.bWaitCursor = false;
                        //commit('clearAuthData');
                        commit('setIsAuthenticated', false);
                        commit('setFailedLogin', true);
                    }
                })
                .catch(error => {
                    console.log('Error de autenticación #0: ', error);
                    state.bWaitCursor = false;

                    //commit('clearAuthData');
                    commit('setIsAuthenticated', false);
                    commit('setFailedLogin', true);
                });
        },
        updateFailedLogin({ commit }, failedLogin) {
            commit('setFailedLogin', failedLogin);
        },
        updateInactiveUser({ commit }, inactiveUser) {
            commit('setInactiveUser', inactiveUser);
        },
        setLogoutTimer({ commit }, expirationTime) {
            setTimeout(() => {
                console.log('Llamando a clearAuthData desde setLogoutTimer');
                commit('clearAuthData');
                router.replace('/sign-in'); //Aparentemente es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
            }, expirationTime * 1000);
        },
        logout({ commit, state }) {
            axios.delete('/sesion/deleteSession/' + state.idToken); //Borra la sesión
            console.log('Llamando a clearAuthData desde logout');
            commit('clearAuthData');
            //localStorage.removeItem('authHeader');
            localStorage.removeItem('token');
            localStorage.removeItem('userID');
            localStorage.removeItem('expirationDate');
            localStorage.removeItem('userEmail');
            //router.replace('/sign-in');//Se supone que es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
            router.replace('/sign-in').catch(err => {}); //Se supone que es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
        },
        tryAutoLogin({ commit, dispatch }) {
            console.log('TryAutoLogin...');
            const token = localStorage.getItem('token');
            if (!token) {
                console.log('No hay token...');
                return;
            }

            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            const now = new Date();

            if (now >= expirationDate) {
                console.log('Time has expired...');
                return;
            }
            const userID = localStorage.getItem('userID');
            this.commit('authUser', {
                //authHeader: authHeader,
                idToken: token,
                userID: userID
            });

            const userEmail = localStorage.getItem('userEmail');
            commit('setIsAuthenticated', true);

            //Carga al usuario logueado:
            dispatch('userAutoLogin', userEmail);

            router.push('/').catch(err => {});
        },
        userAutoLogin({ commit, dispatch, state }, email) {
            if (!state.idToken) {
                return;
            }

            axios
                .get('/usuarios/getByEmail/' + email + '/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de userAutoLogin: ', res);

                    //error 0 = No hay error.
                    if (res.data.error === 1) {
                        console.log('Error. Sesión no válida.');
                        dispatch('logout');
                    } else {
                        const user = res.data;
                        console.log('user = ', user);
                        commit('setUser', user);

                        //Carga todas las tablas de configuración:
                        dispatch('fetchAdminConfigData');
                    }
                })
                .catch(error => {
                    alert('Error en login: ' + error);
                    console.log('Error en login: ', error);
                    dispatch('logout');
                });
        },

        fetchAdminConfigData({ dispatch, state }) {
            if (!state.idToken) {
                return;
            }

            dispatch('fetchUserTypes');
            dispatch('fetchQuestionnaires');

            dispatch('fetchLanguages');
            dispatch('fetchGenders');
            dispatch('fetchOrganizationalLevels');
            dispatch('fetchAgeRanges');
            dispatch('fetchUsers');
        },

        updateUserSurvey({ commit }, userSurvey) {
            commit('setUserSurvey', userSurvey);
        },

        testExit({ state }) {
            axios
                .get('/roles/getRoles/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('getRoles, res = ', res);
                })
                .catch(error => {
                    console.log('Error en getRoles, error = ', error);
                });
        },

        getUserSurveyData({ dispatch, state }) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .get(
                    '/encuestas/getDataEncuestasById/' +
                        state.userSurvey.encuestaID +
                        '/' +
                        state.userID +
                        '/' +
                        state.userSurveyLangID +
                        '/' +
                        state.idToken,
                    { crossDomain: true }
                )
                //axios.get('/encuestas/getDataEncuestasById/' + state.userSurvey.encuestaID + '/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('getUserSurveyData, res = ', res);
                    const surveyData = res.data;
                    if (surveyData.encuestaID !== 0) {
                        console.log('getUserSurveyData, surveyData = ', surveyData);
                        dispatch('updateUserSurveyData', surveyData);
                    }

                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getUserSurveyData, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updateUserSurveyData({ dispatch, commit, state }, userSurveyData) {
            state.bWaitCursor = true;
            commit('setUserSurveyData', userSurveyData);
            state.bWaitCursor = false;

            router.push('/usersurvey').catch(err => {});
        },

        updateUserSurveyResults({ dispatch, commit, state }, surveyResults) {
            state.bWaitCursor = true;
            commit('setUserSurveyResults', surveyResults);
            state.bWaitCursor = false;

            router.push('/surveyResults').catch(err => {});
        },

        fetchLanguages({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/idiomas/getIdiomas/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchLanguages, res = ', res);
                    const data = res.data;
                    const languages = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const language = data[i];
                        languages.push(language);
                    }
                    state.bWaitCursor = false;
                    commit('setLanguages', languages);
                })
                .catch(error => {
                    console.log('Error en FetchLanguages, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchGenders({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/genero/getGeneros/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchGenders, res = ', res);
                    const data = res.data;
                    const genders = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const gender = data[i];
                        genders.push(gender);
                    }
                    state.bWaitCursor = false;
                    commit('setGenders', genders);
                })
                .catch(error => {
                    console.log('Error en FetchGenders, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchOrganizationalLevels({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/nivelOrganizacional/getNivelesOrganizacionales/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('fetchOrganizationalLevels, res = ', res);
                    const data = res.data;
                    const levels = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const level = data[i];
                        levels.push(level);
                    }
                    state.bWaitCursor = false;
                    commit('setOrganizationalLevels', levels);
                })
                .catch(error => {
                    console.log('Error en fetchOrganizationalLevels, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchAgeRanges({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/rangoEdad/getRangosEdad/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('fetchAgeRanges, res = ', res);
                    const data = res.data;
                    const ranges = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const range = data[i];
                        ranges.push(range);
                    }
                    state.bWaitCursor = false;
                    commit('setAgeRanges', ranges);
                })
                .catch(error => {
                    console.log('Error en FethAgeRanges, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchUserTypes({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/tiposUsuario/getTiposUsuario/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchUserTypes, res = ', res);
                    const userTypes = res.data;
                    state.bWaitCursor = false;
                    commit('setUserTypes', userTypes);
                })
                .catch(error => {
                    console.log('Error en fetchUserTypes, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchQuestionnaires({ commit, state }) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            // var casos = [
            //     {
            //         id: 1,
            //         numero: 1,
            //         titulo: 'Miscelánea heredada'
            //     },
            //     {
            //         id: 2,
            //         numero: 2,
            //         titulo: 'Tienda Departamental'
            //     },
            //     {
            //         id: 3,
            //         numero: 3,
            //         titulo: 'Empleado inconforme'
            //     },
            //     {
            //         id: 4,
            //         numero: 4,
            //         titulo: 'Presidente de izquierda'
            //     }
            // ];

            // commit('setQuestionnaires', casos);
            //Fin Temp.

            axios
                .get('/casos/getCasos/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('fetchQuestionnaires, res = ', res);
                    const casos = res.data;
                    console.log('questionnaires = ', casos);
                    commit('setQuestionnaires', casos);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en fetchQuestionnaires, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchSurveys({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/survey/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('FetchSurveys, res = ', res);
                    const surveys = res.data;
                    state.bWaitCursor = false;
                    commit('setSurveys', surveys);
                    router.push('/surveys').catch(err => {});
                })
                .catch(error => {
                    console.log('Error en FetchSurveys, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updateSurveyLoaded({ commit }, bLoaded) {
            commit('setSurveyLoaded', bLoaded);
        },

        updateQuestionnaireLoaded({ commit }, bLoaded) {
            commit('setQuestionnaireLoaded', bLoaded);
        },

        updateLoadingSurvey({ commit }, bLoading) {
            commit('setLoadingSurvey', bLoading);
        },

        updateLoadingQuestionnaire({ commit }, bLoading) {
            commit('setLoadingQuestionnaire', bLoading);
        },

        updateSurvey({ commit, state }, survey) {
            commit('setSurveyData', survey);
            state.bSurveyLoaded = true;
            state.bLoadingSurvey = false;
        },

        // initSurveyData({ commit }) {
        //     commit('initSurveyData');
        // },

        initQuestionnaireData({ commit }) {
            commit('initQuestionnaireData');
        },

        updateSurveyUsers({ commit, state }, users) {
            state.survey.usuarios = users;
        },

        getSurveyData({ commit, dispatch, state }, surveyID) {
            state.bWaitCursor = true;
            //dispatch('initSurveyData');

            axios
                .get('/survey/getById/' + surveyID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('getSurveyData, res = ', res);
                    const survey = res.data;
                    if (survey.encuestaid !== 0) {
                        console.log('getSurveyData, survey = ', survey);
                        dispatch('updateSurvey', survey);
                    }

                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getSurveyData, error = ', error);
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:
            // var temp = {
            //     id: 1,
            //     encuestadorID: 1,
            //     fecha: '2021-06-25',
            //     nombre: 'Luis',
            //     apaterno: 'Pérez',
            //     amaterno: 'González',
            //     edadID: 2,
            //     sexo: 0,
            //     nivelID: 3,
            //     email: 'luis@correo.com',
            //     idiomaID: 0
            // };
            //Fin pruebas
        },

        newSurvey({ dispatch, state }, survey) {
            if (!state.idToken) {
                return;
            }
            console.log('Survey to save: ', survey);

            state.bWaitCursor = true;
            //state.bSearchNewSurvey = true;

            axios
                .post('/survey/getSurveyData/' + state.idToken, survey)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('newSurvey, res = ', res);
                    if (res.data.error === 1) {
                        //No hay cuestionarios en el idioma seleccionado...
                        dispatch('updateErrorNoLang', true);
                    } else {
                        dispatch('updateUserSurveyData', res.data);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewSurvey = false;
                });

            //Inicio pruebas: ***********************************************************************************************

            // var surveyData = {
            //     fecha: '20/07/2021',
            //     apaterno: 'González',
            //     amaterno: 'Ruiz',
            //     nombre: 'Fernando',
            //     edadid: 3,
            //     generoid: 2,
            //     nivelorganizacionalid: 2,
            //     idiomaid: 1,
            //     email: 'fernando@hotmail.com',
            //     casos: [
            //         {
            //             casoid: 1,
            //             numCaso: 1,
            //             titulo: 'Tienda heredada',
            //             intro:
            //                 'Tienes un puesto ejecutivo en una de las tiendas departamentales más grandes de México. Heredas una miscelánea y no sabes si te vas a quedar con ella o no.',
            //             situaciones: [
            //                 {
            //                     situacionid: 1,
            //                     tipoSituacion: 1,
            //                     numSituacion: 1,
            //                     situacion:
            //                         'Necesitas decidir si tomarás o no la responsabilidad de operar la tienda que te acaban de heredar. ¿Qué elementos considerarías para decidir si tomas o no la responsabilidad de administrar la tienda de abarrotes?',
            //                     respuestas: [
            //                         {
            //                             numRespuesta: 1,
            //                             respuestaID: 1,
            //                             respuesta:
            //                                 'La rentabilidad de la tienda, ingresos, margen, número de empleados, etc.',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 2,
            //                             respuestaID: 2,
            //                             respuesta:
            //                                 'Conocer el estado en general de la tienda. Me gustaría visitarla para ver si me están dejando algo en mal estado. Ubicación.',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 3,
            //                             respuestaID: 3,
            //                             respuesta:
            //                                 'Me gustaría saber el valor de venta de la tienda de abarrotes. Ver si se puede vender.',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 4,
            //                             respuestaID: 4,
            //                             respuesta:
            //                                 'Su respuesta denota falta de atención a las instrucciones o bien simplemente divagó en su respuesta.',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 5,
            //                             respuestaID: 5,
            //                             respuesta:
            //                                 'Les permitiría administrarla por un tiempo y luego evaluaría los avances con ellos. Buscaría que se fueron por algo más fuerte para su desarrollo. Les dejaría correr un piloto.',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 6,
            //                             respuestaID: 6,
            //                             respuesta:
            //                                 'Trataría de entender bien sus intenciones. ¿qué consideran que la tienda puede aportar a sus carreras profesionales? Puede ser formativo para ellos.',
            //                             contestada: 0
            //                         }
            //                     ],
            //                     autoevaluacion: null
            //                 }, //Fin situación 1
            //                 {
            //                     situacionid: 2,
            //                     tipoSituacion: 2, //Situación priorizada
            //                     numSituacion: 1,
            //                     situacion:
            //                         'La Cámara de la Industria Farmacéutica tuvo su proceso interno para la asignación de su nuevo Presidente. Fuiste elegido para tomar el cargo. A continuación te pedimos priorizar algunas acciones que pudieras tomar a tu ingreso al cargo. Prioriza las acciones que se te dan, no puedes agregar ninguna, pero puedes decidir eliminar las que consideres improcedentes. Para decidir lo anterior considera las implicaciones de tener un nuevo Presidente en el país.',
            //                     respuestas: [
            //                         {
            //                             numRespuesta: 1,
            //                             respuestaID: 1,
            //                             respuesta:
            //                                 'Convocar a una reunión con las principales empresas de la Cámara para presentarme y conocer sus necesidades ',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 2,
            //                             respuestaID: 2,
            //                             respuesta:
            //                                 'Buscar una cita con el nuevo Presidente del país para presentarme como líder la Cámara',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 3,
            //                             respuestaID: 3,
            //                             respuesta:
            //                                 'Trabajaría con el equipo jurídico de la Cámara para preparar nuestra defensa en caso de que el Presidente decida salir del tratado de libre comercio',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 4,
            //                             respuestaID: 4,
            //                             respuesta:
            //                                 'Lanzaría un comunicado a los miembros de la Cámara para alertarlos sobre los posibles riesgos implícitos en los planes del nuevo gobierno.',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 5,
            //                             respuestaID: 5,
            //                             respuesta:
            //                                 'Esperaría un par de meses a ver como se desarrolla el nuevo Presidente y luego decidiría sobre mis acciones. En realidad no tengo claro la forma en que finalmente el Presidente decidirá actuar.',
            //                             contestada: 0
            //                         },
            //                     ],
            //                     autoevaluacion: null
            //                 }, //Fin situación 2
            //                 {
            //                     situacionid: 3,
            //                     tipoSituacion: 1,
            //                     numSituacion: 3,
            //                     situacion:
            //                         'Lorem ipsum dolor sit amet, consectetur adipisci tempor incidunt ut labore et dolore magna aliqua veniam, quis nostrud exercitation ullamcorpor s commodo consequat. Duis autem vel eum irrure esse molestiae consequat, vel illum dolore eu fugi et iusto odio dignissim qui blandit praesent luptat exceptur sint occaecat cupiditat non provident, deserunt mollit anim id est laborum et dolor fuga distinct. Nam liber tempor cum soluta nobis elige quod maxim placeat facer possim omnis volupt',
            //                     respuestas: [
            //                         {
            //                             numRespuesta: 1,
            //                             respuestaID: 7,
            //                             respuesta:
            //                                 'Lorem ipsum dolor sit amet, consectetur adipisci tempor incidunt ut labore',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 2,
            //                             respuestaID: 8,
            //                             respuesta:
            //                                 'Consectetur adipisci tempor incidunt ut labore et dolore magna aliqua veniam.',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 3,
            //                             respuestaID: 9,
            //                             respuesta:
            //                                 'Quis nostrud exercitation ullamcorpor s commodo consequat.',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 4,
            //                             respuestaID: 10,
            //                             respuesta:
            //                                 'Duis autem vel eum irrure esse molestiae consequat.',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 5,
            //                             respuestaID: 11,
            //                             respuesta:
            //                                 'Vel illum dolore eu fugi et iusto odio dignissim qui blandit praesent luptat exceptur sint occaecat cupiditat non provident, deserunt mollit anim id est laborum et dolor fuga distinct.',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 6,
            //                             respuestaID: 12,
            //                             respuesta:
            //                                 'Nam liber tempor cum soluta nobis elige quod maxim placeat facer possim omnis volupt.',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 7,
            //                             respuestaID: 13,
            //                             respuesta: 'Lorem ipsum dolor si amet.',
            //                             contestada: 0
            //                         },
            //                         {
            //                             numRespuesta: 8,
            //                             respuestaID: 14,
            //                             respuesta:
            //                                 'Consectetur adipisci tempor incidunt ut labore et dolore magna aliqua veniam.',
            //                             contestada: 0
            //                         }
            //                     ],
            //                     autoevaluacion: {
            //                         texto:
            //                             'Les permitiría a mis hijos administrar la tienda por dos años. Al final de los dos años me sentaría con ellos para hacer una revisión de su experiencia y saber si desean continuar con la operación o tienen otros planes profesionales. Quiero estar seguro que no se sientan obligados a continuar con la operación y trabajen en proyectos que en verdad sean apasionantes para ellos, fomentando así su desarrollo. Lo importante es trabajar en su futuro profesional más que definir el destino de la tienda de abarrotes.',
            //                         tipoAutoevaluación: 0,
            //                         respuesta: null, //0, 1, 2, 3
            //                         respuestaReal: null, //0, 1, 2, 3
            //                         infoComplementaria: null //0, 1, 2, 3
            //                     }
            //                 } //Fin Situación 2
            //             ]
            //         } //Fin Caso 1
            //     ] //Fin casos.
            // };

            // var res = {
            //     data: surveyData
            // };
            //dispatch('updateUserSurveyData', res.data);

            //Fin pruebas ***********************************************
        },

        sendSurvey({ dispatch, state }, survey) {
            if (!state.idToken) {
                return;
            }
            console.log('Survey to send: ', survey);

            state.bWaitCursor = true;

            axios
                .post('/survey/saveSurveyData/' + state.idToken, survey)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('newSurvey, res = ', res);
                    if (res.data.error === 1) {
                        //Error al procesar la encuesta...
                        dispatch('updateSurveyResultsError', true);
                    } else {
                        dispatch('updateUserSurveyResults', res.data);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewSurvey = false;
                });

            //Inicio pruebas......
            // var surveyResults = {
            //     encuestaID: 1,
            //     conceptos: [
            //         {
            //             resultados: [103, 47.9, 4, 33.3, 14.6]
            //         },
            //         {
            //             resultados: [290, 29.9, 4, 26.7, 66.3]
            //         },
            //         {
            //             resultados: [92, 68.7, 8, 38.1, 30.6]
            //         },
            //         {
            //             resultados: [57, 73.1, 2, 12.5, 60.6]
            //         },
            //         {
            //             resultados: [542, 73.3, 18, 28.1, 45.2]
            //         },
            //         {
            //             resultados: [32, 59.3, 2, 9.5, 49.7]
            //         },
            //         {
            //             resultados: [71, 83.4, 0, 0, 93.4]
            //         },
            //         {
            //             resultados: [66, 93.0, 3, 23.1, 69.9]
            //         },
            //         {
            //             resultados: [169, 84.1, 5, 12.5, 71.6]
            //         },
            //         {
            //             resultados: [24, 68.6, 4, 33.3, 35.2]
            //         },
            //         {
            //             resultados: [36, 78.3, 21, 87.5, -9.2]
            //         },
            //         {
            //             resultados: [12, 66.7, 6, 28.6, 38.1]
            //         },
            //         {
            //             resultados: [72, 72.7, 31, 54.4, 18.3]
            //         },
            //         {
            //             resultados: [783, 75.4, 54, 33.5, 41.8]
            //         }
            //     ]
            // };

            // var res = {
            //     data: surveyResults
            // };
            // dispatch('updateUserSurveyResults', res.data);
            // //dispatch('updateSurveyResultsError', true);
            // state.bWaitCursor = false;
            //Fin pruebas.
        },

        updateErrorNoLang({ commit }, bError) {
            commit('setErrorNoLang', bError);
        },

        updateSurveyResultsError({ commit }, bError) {
            commit('setSurveyResultsError', bError);
        },

        updateSelectedQuestionnaireIndex({ commit }, index) {
            commit('setSelectedQuestionnaireIndex', index);
        },

        updateSearchNewQuestionnaire({ commit }, search) {
            commit('setSearchNewQuestionnaire', search);
        },

        updateNewQuestionnaireID({ commit }, id) {
            commit('setNewQuestionnaireID', id);
        },

        getQuestionnaireData({ commit, dispatch, state }, questionnaireID) {
            state.bWaitCursor = true;
            dispatch('initQuestionnaireData');
            axios
                .get('/casos/getById/' + questionnaireID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    // var temp = {
                    //     id: 1,
                    //     numero: 1,
                    //     titulo: 'Tienda heredada',
                    //     idiomas: [
                    //         {
                    //             idiomaid: 1
                    //         },
                    //         {
                    //             idiomaid: 2
                    //         }
                    //     ],
                    //     introIdiomas: [
                    //         {
                    //             idiomaid: 1,
                    //             intro:
                    //                 'Tienes un puesto ejecutivo en una de las tiendas departamentales más grandes de México. Heredas una miscelánea y no sabes si te vas a quedar con ella o no.'
                    //         },
                    //         {
                    //             idiomaid: 2,
                    //             intro:
                    //                 "You have an executive position in one of the largest department stores in Mexico. You inherit a convenience store and you don't know if you are going to keep it or not."
                    //         }
                    //     ],
                    //     situaciones: [
                    //         {
                    //             situacionid: 1,
                    //             tipoSituacion: 1, //Normal
                    //             casoid: 1,
                    //             numero: 1
                    //         },
                    //         {
                    //             situacionid: 2,
                    //             tipoSituacion: 2, //Priorizada
                    //             casoid: 1,
                    //             numero: 2
                    //         }
                    //{
                    //             situacionid: 3,
                    //             tipoSituacion: 1,
                    //             casoid: 1,
                    //             numero: 3
                    //         }
                    //     ],
                    //     situacionesIdiomas: [
                    //         {
                    //             situacionid: 1,
                    //             idiomaid: 1,
                    //             situacion:
                    //                 'Necesitas decidir si tomarás o no la responsabilidad de operar la tienda que te acaban de heredar. ¿Qué elementos considerarías para decidir si tomas o no la responsabilidad de administrar la tienda de abarrotes?'
                    //         },
                    //         {
                    //             situacionid: 1,
                    //             idiomaid: 2,
                    //             situacion:
                    //                 'You need to decide whether or not you will take responsibility for operating the store that you just inherited. What elements would you consider in deciding whether or not to take on the responsibility of running the grocery store?'
                    //         },
                    //{
                    //             situacionid: 2,
                    //             idiomaid: 1,
                    //             situacion:
                    //                 'La Cámara de la Industria Farmacéutica tuvo su proceso interno para la asignación de su nuevo Presidente. Fuiste elegido para tomar el cargo. A continuación te pedimos priorizar algunas acciones que pudieras tomar a tu ingreso al cargo. Prioriza las acciones que se te dan, no puedes agregar ninguna, pero puedes decidir eliminar las que consideres improcedentes. Para decidir lo anterior considera las implicaciones de tener un nuevo Presidente en el país.'
                    //         },
                    //         {
                    //             situacionid: 2,
                    //             idiomaid: 2,
                    //             situacion:
                    //                 'The Chamber of the Pharmaceutical Industry had its internal process for the appointment of its new President. You were chosen to take over. Next, we ask you to prioritize some actions that you could take upon your entry into office. Prioritize the actions that are given to you, you cannot add any, but you can decide to eliminate those that you consider inappropriate. To decide the above, consider the implications of having a new President in the country. '
                    //         }
                    //         {
                    //             situacionid: 3,
                    //             idiomaid: 1,
                    //             situacion:
                    //                 'Tus dos hijos (19 y 21 años) estudian administración de empresas en una universidad de prestigio del país. Ambos te piden tener la oportunidad de participar en la administración de la tienda, pues tienen muchas ideas para cambiar su nivel de rentabilidad y la forma en la que opera la misma. Piensan que es una gran oportunidad profesional para ellos. ¿Qué respuesta le darías a tus hijos? ¿Les dejarías o no participar en la administración de la tienda?'
                    //         },
                    //         {
                    //             situacionid: 3,
                    //             idiomaid: 2,
                    //             situacion:
                    //                 'Your two sons (19 and 21 years old) study business administration at a prestigious national university. They both ask you to have the opportunity to participate in the management of the store, as they have many ideas to change its level of profitability and the way in which it operates. They think it is a great career opportunity for them. What answer would you give your children? Would you or not let them participate in the management of the store?'
                    //         }
                    //     ],
                    //     respuestas: [
                    //         {
                    //             situacionid: 1,
                    //             respuestaid: 1,
                    //             analisis: 1,
                    //             costoBeneficio: 0,
                    //             largoPlazo: 0,
                    //             pensamientoConceptual: 1,
                    //             interpersonal: 0,
                    //             relacionamientoEstrategico: 0,
                    //             social: 0,
                    //             autoconocimiento: 0,
                    //             ajuste: 0,
                    //             etica: 0,
                    //             relacionamientoEstrategico1: 0,
                    //             relacionamientoEstrategico3: 0,
                    //             relacionamientoEstrategico5: 0,
                    //             relacionamientoEstrategico0: 0,
                    //             relacionamientoSocial1: 0,
                    //             relacionamientoSocial3: 0,
                    //             relacionamientoSocial5: 0,
                    //             relacionamientoSocial0: 0,
                    //         },
                    //         {
                    //             situacionid: 1,
                    //             respuestaid: 2,
                    //             analisis: 1,
                    //             costoBeneficio: 0,
                    //             largoPlazo: 0,
                    //             pensamientoConceptual: 1,
                    //             interpersonal: 0,
                    //             relacionamientoEstrategico: 0,
                    //             social: 0,
                    //             autoconocimiento: 0,
                    //             ajuste: 0,
                    //             etica: 0,
                    //             relacionamientoEstrategico1: 0,
                    //             relacionamientoEstrategico3: 0,
                    //             relacionamientoEstrategico5: 0,
                    //             relacionamientoEstrategico0: 0,
                    //             relacionamientoSocial1: 0,
                    //             relacionamientoSocial3: 0,
                    //             relacionamientoSocial5: 0,
                    //             relacionamientoSocial0: 0,
                    //         },
                    //         {
                    //             situacionid: 2,
                    //             respuestaid: 3,
                    //             analisis: 1,
                    //             costoBeneficio: 0,
                    //             largoPlazo: 0,
                    //             pensamientoConceptual: 1,
                    //             interpersonal: 0,
                    //             relacionamientoEstrategico: 0,
                    //             social: 0,
                    //             autoconocimiento: 0,
                    //             ajuste: 0,
                    //             etica: 0,
                    //             relacionamientoEstrategico1: 0,
                    //             relacionamientoEstrategico3: 0,
                    //             relacionamientoEstrategico5: 0,
                    //             relacionamientoEstrategico0: 0,
                    //             relacionamientoSocial1: 0,
                    //             relacionamientoSocial3: 0,
                    //             relacionamientoSocial5: 0,
                    //             relacionamientoSocial0: 0,
                    //         },
                    //         {
                    //             situacionid: 1,
                    //             respuestaid: 4,
                    //             analisis: 1,
                    //             costoBeneficio: 0,
                    //             largoPlazo: 0,
                    //             pensamientoConceptual: 1,
                    //             interpersonal: 0,
                    //             relacionamientoEstrategico: 0,
                    //             social: 0,
                    //             autoconocimiento: 0,
                    //             ajuste: 0,
                    //             etica: 0,
                    //             relacionamientoEstrategico1: 0,
                    //             relacionamientoEstrategico3: 0,
                    //             relacionamientoEstrategico5: 0,
                    //             relacionamientoEstrategico0: 0,
                    //             relacionamientoSocial1: 0,
                    //             relacionamientoSocial3: 0,
                    //             relacionamientoSocial5: 0,
                    //             relacionamientoSocial0: 0,
                    //         },
                    //         {
                    //             situacionid: 2,
                    //             respuestaid: 4,
                    //             analisis: 0,
                    //             costoBeneficio: 0,
                    //             largoPlazo: 0,
                    //             pensamientoConceptual: 0,
                    //             interpersonal: 0,
                    //             relacionamientoEstrategico: 0,
                    //             social: 0,
                    //             autoconocimiento: 0,
                    //             ajuste: 0,
                    //             etica: 0,
                    //             relacionamientoEstrategico1: 0,
                    //             relacionamientoEstrategico3: 0,
                    //             relacionamientoEstrategico5: 0,
                    //             relacionamientoEstrategico0: 0,
                    //             relacionamientoSocial1: 0,
                    //             relacionamientoSocial3: 0,
                    //             relacionamientoSocial5: 0,
                    //             relacionamientoSocial0: 0,
                    //
                    //         },
                    //         {
                    //             situacionid: 2,
                    //             respuestaid: 5,
                    //             analisis: 1,
                    //             costoBeneficio: 0,
                    //             largoPlazo: 0,
                    //             pensamientoConceptual: 1,
                    //             interpersonal: 0,
                    //             relacionamientoEstrategico: 0,
                    //             social: 0,
                    //             autoconocimiento: 0,
                    //             ajuste: 0,
                    //             etica: 0
                    //         },
                    //         {
                    //             situacionid: 2,
                    //             respuestaid: 6,
                    //             analisis: 1,
                    //             costoBeneficio: 0,
                    //             largoPlazo: 0,
                    //             pensamientoConceptual: 1,
                    //             interpersonal: 0,
                    //             relacionamientoEstrategico: 0,
                    //             social: 0,
                    //             autoconocimiento: 0,
                    //             ajuste: 0,
                    //             etica: 0
                    //         },
                    //         {
                    //             situacionid: 2,
                    //             respuestaid: 7,
                    //             analisis: 1,
                    //             costoBeneficio: 0,
                    //             largoPlazo: 0,
                    //             pensamientoConceptual: 1,
                    //             interpersonal: 0,
                    //             relacionamientoEstrategico: 0,
                    //             social: 0,
                    //             autoconocimiento: 0,
                    //             ajuste: 0,
                    //             etica: 0
                    //         },
                    //         {
                    //             situacionid: 3,
                    //             respuestaid: 8,
                    //             analisis: 1,
                    //             costoBeneficio: 0,
                    //             largoPlazo: 0,
                    //             pensamientoConceptual: 1,
                    //             interpersonal: 0,
                    //             relacionamientoEstrategico: 0,
                    //             social: 0,
                    //             autoconocimiento: 0,
                    //             ajuste: 0,
                    //             etica: 0
                    //         }
                    //     ],
                    //     respuestasIdiomas: [
                    //         {
                    //             respuestaid: 1,
                    //             idiomaid: 1,
                    //             respuesta:
                    //                 'La rentabilidad de la tienda, ingresos, margen, número de empleados, etc.'
                    //         },
                    //         {
                    //             respuestaid: 1,
                    //             idiomaid: 2,
                    //             respuesta:
                    //                 'The profitability of the store, revenue, margin, number of employees, etc.'
                    //         },
                    //         {
                    //             respuestaid: 2,
                    //             idiomaid: 1,
                    //             respuesta:
                    //                 'Conocer el estado en general de la tienda. Me gustaría visitarla para ver si me están dejando algo en mal estado. Ubicación.'
                    //         },
                    //         {
                    //             respuestaid: 2,
                    //             idiomaid: 2,
                    //             respuesta:
                    //                 "Get to know the general condition of the store. I'd like to visit the store to see if they are leaving me something in bad shape. Location."
                    //         },
                    //         {
                    //             respuestaid: 3,
                    //             idiomaid: 1,
                    //             respuesta:
                    //                 'Me gustaría saber el valor de venta de la tienda de abarrotes. Ver si se puede vender.'
                    //         },
                    //         {
                    //             respuestaid: 3,
                    //             idiomaid: 2,
                    //             respuesta:
                    //                 "I'd like to know the retail value of the grocery store. See if it can be sold."
                    //         },
                    //         {
                    //             respuestaid: 4,
                    //             idiomaid: 1,
                    //             respuesta:
                    //                 "Convocar a una reunión con las principales empresas de la Cámara para presentarme y conocer sus necesidades"
                    //         },
                    //          {
                    //             respuestaid: 4,
                    //             idiomaid: 2,
                    //             respuesta:
                    //                 "ASDFASDFADF Ingléx"
                    //         },
                    //         {
                    //             respuestaid: 5,
                    //             idiomaid: 1,
                    //             respuesta:
                    //                 "Buscar una cita con el nuevo Presidente del país para presentarme como líder la Cámara"
                    //         },
                    //         {
                    //             respuestaid: 5,
                    //             idiomaid: 2,
                    //             respuesta:
                    //                 "AAASSSS"
                    //         },
                    //         {
                    //             respuestaid: 9,
                    //             idiomaid: 1,
                    //             respuesta:
                    //                 'Su respuesta denota falta de atención a las instrucciones o bien simplemente divagó en su respuesta.'
                    //         },
                    //         {
                    //             respuestaid: 9,
                    //             idiomaid: 2,
                    //             respuesta:
                    //                 'His/her answer denotes inattention to the instructions or he/she simply rambled on in his/her answer.'
                    //         },
                    //         {
                    //             respuestaid: 10,
                    //             idiomaid: 1,
                    //             respuesta:
                    //                 'Les permitiría administrarla por un tiempo y luego evaluaría los avances con ellos. Buscaría que se fueron por algo más fuerte para su desarrollo. Les dejaría correr un piloto.'
                    //         },
                    //         {
                    //             respuestaid: 10,
                    //             idiomaid: 2,
                    //             respuesta:
                    //                 'I would allow them to manage it for a while and then evaluate the progress with them. I would find that they left for something stronger for their development. A pilot would let them run.'
                    //         },
                    //         {
                    //             respuestaid: 11,
                    //             idiomaid: 1,
                    //             respuesta:
                    //                 'Trataría de entender bien sus intenciones. ¿qué consideran que la tienda puede aportar a sus carreras profesionales? Puede ser formativo para ellos.'
                    //         },
                    //         {
                    //             respuestaid: 11,
                    //             idiomaid: 2,
                    //             respuesta:
                    //                 'I would try to understand their intentions well. What do you think the store can contribute to your professional careers? It can be formative for them.'
                    //         },
                    //         {
                    //             respuestaid: 12,
                    //             idiomaid: 1,
                    //             respuesta:
                    //                 'Habría que ver si los empleados pudiera se administrados por ellos y si serían bienvenidos o capaces de hacerlo. El negocio es el negocio pero les exigiría resultados. De manera gradual. Mi supervisión sería muy importante.'
                    //         },
                    //         {
                    //             respuestaid: 12,
                    //             idiomaid: 2,
                    //             respuesta:
                    //                 'It would be necessary to see if the employees could be managed by them and if they would be welcomed or able to do so. Business is business but I would demand results from them. Gradually. My supervision would be very important.'
                    //         },
                    //         {
                    //             respuestaid: 13,
                    //             idiomaid: 1,
                    //             respuesta:
                    //                 'Su respuesta denota falta de atención a las instrucciones o bien simplemente divagó en su respuesta. '
                    //         },
                    //         {
                    //             respuestaid: 13,
                    //             idiomaid: 2,
                    //             respuesta:
                    //                 'His/her answer denotes inattention to the instructions or he/she simply rambled on in his/her answer.'
                    //         }
                    //     ],
                    //     autoevaluaciones: [
                    //         {
                    //             situacionid: 3,
                    //             autoevaluacionid: 1,
                    //             tipoEvaluacion: 0,
                    //             mantengoBien: 1,
                    //             mantengoMal: 2,
                    //             cambioBien: 3,
                    //             cambioMal: 4,
                    //             mejor: [1, -3, -5, -7],
                    //             muySimilar: [3, 1, -3, -5],
                    //             omitiUnPunto: [5, 3, 1, -3],
                    //             omitiDosPuntos: [7, 5, 3, 1]
                    //         }
                    //     ],
                    //     autoevaluacionesIdiomas: [
                    //         {
                    //             autoevaluacionid: 1,
                    //             idiomaid: 1,
                    //             autoevaluacion:
                    //                 'Les permitiría a mis hijos administrar la tienda por dos años. Al final de los dos años me sentaría con ellos para hacer una revisión de su experiencia y saber si desean continuar con la operación o tienen otros planes profesionales. Quiero estar seguro que no se sientan obligados a continuar con la operación y trabajen en proyectos que en verdad sean apasionantes para ellos, fomentando así su desarrollo. Lo importante es trabajar en su futuro profesional más que definir el destino de la tienda de abarrotes.'
                    //         },
                    //         {
                    //             autoevaluacionid: 1,
                    //             idiomaid: 2,
                    //             autoevaluacion:
                    //                 'I would allow my children to run the store for two years. At the end of the two years I would sit down with them to review their experience and find out if they want to continue with the operation or have other professional plans. I want to be sure that they do not feel obliged to continue with the operation and work on projects that are truly exciting for them, thus promoting their development. The important thing is to work on your professional future rather than defining the destiny of the grocery store.'
                    //         }
                    //     ]
                    // };
                    // state.bWaitCursor = false;

                    // var res = {
                    //     data: temp
                    // };

                    commit('setQuestionnaireLanguages', []);
                    commit('setQuestionnaireIntros', []);
                    commit('setQuestionnaireAnswers', []);
                    commit('setQuestionnaireAnswersLang', []);
                    commit('setQuestionnaireSituations', []);
                    commit('setQuestionnaireSituationsLang', []);
                    commit('setQuestionnaireAutoevaluations', []);
                    commit('setQuestionnaireAutoevaluationsLang', []);

                    console.log('getQuestionnaireData, res = ', res);
                    const questionnaireLanguages = res.data.idiomas;
                    const questionnaireIntros = res.data.introIdiomas;
                    const questionnaireSituations = res.data.situaciones;
                    const questionnaireSituationsLang = res.data.situacionesIdiomas;
                    const questionnaireAnswers = res.data.respuestas;
                    const questionnaireAnswersLang = res.data.respuestasIdiomas;
                    const questionnaireAutoevaluations = res.data.autoevaluaciones;
                    const questionnaireAutoevaluationsLang = res.data.autoevaluacionesIdiomas;

                    if (
                        questionnaireLanguages !== undefined &&
                        questionnaireIntros !== undefined &&
                        questionnaireSituations !== undefined &&
                        questionnaireSituationsLang !== undefined &&
                        questionnaireAnswers !== undefined &&
                        questionnaireAnswersLang !== undefined &&
                        questionnaireAutoevaluations !== undefined &&
                        questionnaireAutoevaluationsLang !== undefined
                    ) {
                        commit('setQuestionnaireLanguages', questionnaireLanguages);
                        commit('setQuestionnaireIntros', questionnaireIntros);
                        commit('setQuestionnaireSituations', questionnaireSituations);
                        commit('setQuestionnaireSituationsLang', questionnaireSituationsLang);
                        commit('setQuestionnaireAnswers', questionnaireAnswers);
                        commit('setQuestionnaireAnswersLang', questionnaireAnswersLang);
                        commit('setQuestionnaireAutoevaluations', questionnaireAutoevaluations);
                        commit(
                            'setQuestionnaireAutoevaluationsLang',
                            questionnaireAutoevaluationsLang
                        );

                        dispatch('createQuestionnaireInfo');
                        dispatch('updateQuestionnaireLoaded', true);
                        dispatch('updateLoadingQuestionnaire', false);
                    }
                })
                .catch(error => {
                    console.log('Error en getQuestionnaireData, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        createQuestionnaireInfo({ commit, state }) {
            state.bWaitCursor = true;

            //Crea el arreglo para el único renglón que tendrá la tabla de la introducción del cuestionario
            //y el arreglo para el header de las tablas del cuestionario, con una columna por idioma:

            var introTable = []; //Arreglo con un solo renglón para la tabla de la intro. del cuestionario.
            //Crea el único renglón para la tabla anterior:
            var introTableRow = {
                id: 0
            };

            var questionnaireHeader = []; //Arreglo para el header de las tablas del cuestionario.
            const columnWidth = 100 / state.questionnaireIntros.length;

            var i;
            for (i = 0; i < state.questionnaireIntros.length; i++) {
                var j;
                var langName = '';
                for (j = 0; j < state.languages.length; j++) {
                    if (state.questionnaireIntros[i].idiomaid === state.languages[j].idiomaid) {
                        langName = state.languages[j].idioma;
                        break;
                    }
                }
                const column = {
                    text: langName,
                    value: state.questionnaireIntros[i].idiomaid.toString(),
                    sortable: false,
                    width: columnWidth + '%',
                    divider: true
                };

                //Se crea una nueva columna para el arreglo con el id del idioma como nombre de la columna y con el nombre como contenido:
                const idiomaid = state.questionnaireIntros[i].idiomaid;
                introTableRow[idiomaid] = state.questionnaireIntros[i].intro;

                questionnaireHeader.push(column);
            }

            if (state.questionnaireIntros.length > 0) {
                introTable.push(introTableRow);
            }
            commit('setQuestionnaireIntroTable', introTable);
            //console.log('En createCuestionnaireInfo, questionnaireIntroTable = ', introTable);
            commit('setQuestionnaireTablesHeader', questionnaireHeader);
            //console.log('questionnaireHeader =', questionnaireHeader);

            //La tabla de preguntas es igual a las otras tablas de los cuestionarios, pero incluye una columna para
            //el número de pregunta (al princpio):
            var questionHeader = JSON.parse(JSON.stringify(questionnaireHeader));
            var width = 90 / (questionHeader.length + 1);
            for (i = 0; i < questionHeader.length; i++) {
                questionHeader[i].width = width + '%';
            }

            const answerNumberColumn = {
                text: 'Número',
                value: 'num',
                sortable: false,
                width: '2%',
                divider: true,
                align: 'center'
            };
            //Agrega la columna para el número de pregunta al principio:
            questionHeader.splice(0, 0, answerNumberColumn);

            //Agrega una columna al final para el botón de edición de cada pregunta:
            const editBtnColumn = {
                text: '',
                value: 'control-edit',
                sortable: false,
                width: '5%',
                divider: true,
                align: 'center'
            };
            const editBtnColumn2 = {
                text: '',
                value: 'control-delete',
                sortable: false,
                width: '5%',
                divider: true,
                align: 'center'
            };
            questionHeader.push(editBtnColumn);
            questionHeader.push(editBtnColumn2);

            commit('setQuestionnaireAnswerHeader', questionHeader);

            //Arreglo para las tablas de todas las Situaciones: ***********************************************

            var situationTable = []; //Arreglo para las tablas de las situaciones, en todos los idiomas.
            var autoevaluationTable = []; //Arreglo para las tablas de las autoevaluaciones, en todos los idiomas.
            var questionTable = []; //Arreglo para las tablas de todas las preguntas de todas las situaciones.

            for (i = 0; i < state.questionnaireSituations.length; i++) {
                var situationOneRowTable = []; //Arreglo con un solo renglón, para cada situación, con una columna por idioma.
                var situationTableRow = {
                    id: state.questionnaireSituations[i].situacionid
                };

                var j;
                for (j = 0; j < state.questionnaireSituationsLang.length; j++) {
                    if (
                        state.questionnaireSituations[i].situacionid ===
                        state.questionnaireSituationsLang[j].situacionid
                    ) {
                        const idiomaid = state.questionnaireSituationsLang[j].idiomaid;
                        situationTableRow[idiomaid] =
                            state.questionnaireSituationsLang[j].situacion;
                    }
                }
                situationOneRowTable.push(situationTableRow);
                situationTable.push(situationOneRowTable);

                //Autoevaluación de la situación: ****************************************************************************
                var autoevaluationOneRowTable = []; //Arreglo con un solo renglón, para la autoevaluación, con una columna por idioma.
                var autoevaluationTableRow = {
                    situationid: state.questionnaireSituations[i].situacionid
                };

                var x;
                for (x = 0; x < state.questionnaireAutoevaluations.length; x++) {
                    if (
                        state.questionnaireAutoevaluations[x].situacionid ===
                        state.questionnaireSituations[i].situacionid
                    ) {
                        for (j = 0; j < state.questionnaireAutoevaluationsLang.length; j++) {
                            if (
                                state.questionnaireAutoevaluations[x].autoevaluacionid ===
                                state.questionnaireAutoevaluationsLang[j].autoevaluacionid
                            ) {
                                const idiomaid = state.questionnaireAutoevaluationsLang[j].idiomaid;
                                autoevaluationTableRow[idiomaid] =
                                    state.questionnaireAutoevaluationsLang[j].autoevaluacion;
                            }
                        }
                        break;
                    }
                }
                autoevaluationOneRowTable.push(autoevaluationTableRow);
                autoevaluationTable.push(autoevaluationOneRowTable);

                //Respuestas de la situación: ********************************************************************************
                var answerNumber = 0;

                //Arreglo para las tablas de las respuestas de la competencia: **********************************
                var situationAnswersTable = [];

                for (j = 0; j < state.questionnaireAnswers.length; j++) {
                    //var questionOneRowTable = []; //Arreglo con un solo renglón, para cada pregunta, con una columna por idioma.

                    var questionTableRow = {
                        answerID: state.questionnaireAnswers[j].respuestaid,
                        num: 0
                    };
                    if (
                        state.questionnaireSituations[i].situacionid ===
                        state.questionnaireAnswers[j].situacionid
                    ) {
                        var k;
                        for (k = 0; k < state.questionnaireAnswersLang.length; k++) {
                            if (
                                state.questionnaireAnswers[j].respuestaid ===
                                state.questionnaireAnswersLang[k].respuestaid
                            ) {
                                const idiomaid = state.questionnaireAnswersLang[k].idiomaid;
                                questionTableRow[idiomaid] =
                                    state.questionnaireAnswersLang[k].respuesta;
                            }
                        }

                        //questionOneRowTable.push(questionTableRow);
                        //situationAnswersTable.push(questionOneRowTable);
                        answerNumber += 1;
                        questionTableRow.num = answerNumber;
                        situationAnswersTable.push(questionTableRow);
                    }
                }
                questionTable.push(situationAnswersTable);
            }

            commit('setQuestionnaireSituationTable', situationTable);
            //console.log('situationTable = ', situationTable);

            commit('setQuestionnaireAutoevaluationTable', autoevaluationTable);
            //console.log('autoevaluationTable = ', autoevaluationTable);

            commit('setQuestionnaireAnswerTable', questionTable);
            //console.log('questionnaireAnswerTable = ', questionTable);

            state.bWaitCursor = false;
        },

        saveNewQuestionnaire({ dispatch, state }, questionnaire) {
            if (!state.idToken) {
                return;
            }
            console.log('Questinnaire to save: ', questionnaire);

            state.bWaitCursor = true;
            state.bSearchNewQuestionnaire = true;

            axios
                .post('/casos/' + state.idToken, questionnaire)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('saveNewQuestionnaire, res = ', res);

                    //Se guarda el ID del nuevo caso, para poder seleccionarlo después:
                    dispatch('updateNewQuestionnaireID', res.data.encuestaID);

                    //Se vuelve a pedir al servidor todos las casos:
                    dispatch('fetchQuestionnaires');
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewQuestionnaire = false;
                });
        },

        editQuestionnaire({ dispatch, state }, questionnaire) {
            if (!state.idToken) {
                return;
            }
            console.log('Questinnaire to save: ', questionnaire);

            state.bWaitCursor = true;
            state.bSearchNewQuestionnaire = true;

            axios
                .post('/casos/' + questionnaire.id + '/' + state.idToken, questionnaire)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('editQuestionnaire, res = ', res);

                    // //Se guarda el ID del nuevo caso, para poder seleccionarlo después:
                    // dispatch('updateNewQuestionnaireID', res.data.encuestaID);

                    //Se vuelve a pedir al servidor todos las casos:
                    dispatch('fetchQuestionnaires');
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewQuestionnaire = false;
                });
        },

        updateQuestionnaireLanguages({ commit }, questionnaireLanguages) {
            commit('setQuestionnaireLanguages', questionnaireLanguages);
        },

        updateQuestionnaireSituations({ commit }, questionnaireSituations) {
            commit('setQuestionnaireSituations', questionnaireSituations);
        },

        updateQuestionnaireSituationsLang({ commit }, questionnaireSituationsLang) {
            commit('setQuestionnaireSituationsLang', questionnaireSituationsLang);
        },

        updateQuestionnaireAutoevaluations({ commit }, questionnaireAutoevaluations) {
            commit('setQuestionnaireAutoevaluations', questionnaireAutoevaluations);
        },

        updateQuestionnaireAutoevaluationTable({ commit }, questionnaireAutoevaluationTable) {
            commit('setQuestionnaireAutoevaluationTable', questionnaireAutoevaluationTable);
        },

        updateQuestionnaireAutoevaluationsLang({ commit }, questionnaireAutoevaluationsLang) {
            commit('setQuestionnaireAutoevaluationsLang', questionnaireAutoevaluationsLang);
        },

        updateQuestionnaireIntros({ state }, questionnaireToEdit) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            console.log('Questionnaire to edit = ', questionnaireToEdit);

            axios
                .post('/cuestionarios/updateCuestionario/' + state.idToken, questionnaireToEdit)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Questionnaire name saved, res = ', res);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                });
        },

        updateQuestionnaireAnswers({ commit }, questionnaireAnswers) {
            commit('setQuestionnaireAnswers', questionnaireAnswers);
        },

        updateQuestionnaireAnswersLang({ commit }, questionnaireAnswersLang) {
            commit('setQuestionnaireAnswersLang', questionnaireAnswersLang);
        },

        updateQuestionnaireAnswerTable({ commit }, questionnaireAnswerTable) {
            commit('questionnaireAnswerTable', questionnaireAnswerTable);
        },

        // updateQuestionnaireSituations({ state }) {
        //     if (!state.idToken) {
        //         return;
        //     }

        //     state.bWaitCursor = true;

        //     const compet_Idiomas = {
        //         competenciasIdiomas: state.questionnaireSituationsLang
        //     };

        //     //console.log("compet_Idiomas = ", compet_Idiomas);

        //     axios
        //         .post('/cuestionarios/updateCompetencia/' + state.idToken, compet_Idiomas)
        //         .then(res => {
        //             state.bWaitCursor = false;
        //             console.log('Questionnaire names saved, res = ', res);
        //         })
        //         .catch(error => {
        //             state.bWaitCursor = false;
        //         });
        // },

        updateQuestionnaireAnswer({ state }, questionToEdit) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .post('/cuestionarios/updatePregunta/' + state.idToken, questionToEdit)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Questionnaire question edited, res = ', res);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                });
        },

        deleteQuestionnaire({ state }, questionnaireID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            axios
                .delete('/casos/deleteCaso/' + questionnaireID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Questionnaire deleted, res = ', res);

                    if (res.data.casoBorrado === false) {
                        state.bQuestionnaireNotDeletedWarning = true;
                        state.bServerResponse = true;
                    } else {
                        state.bQuestionnaireNotDeletedWarning = false;
                        state.bServerResponse = true;
                    }
                })
                .catch(error => {
                    state.bWaitCursor = false;
                });
        },

        deleteSurvey({ state }, surveyID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            axios
                .delete('/encuestas/deleteEncuesta/' + surveyID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Survey deleted, res = ', res);

                    if (res.data.encuestaBorrada === false) {
                        state.bQuestionnaireNotDeletedWarning = true;
                        state.bServerResponse = true;
                    } else {
                        state.bQuestionnaireNotDeletedWarning = false;
                        state.bServerResponse = true;
                    }
                })
                .catch(error => {
                    state.bWaitCursor = false;
                });
        },

        updateQuestionnaireNotDeletedWarning({ commit }, bWarning) {
            commit('setQuestionnaireNotDeletedWarning', bWarning);
        },

        updateServerResponse({ commit }, bResponse) {
            commit('setServerResponse', bResponse);
        },

        updateSelectedSurveyIndex({ commit }, index) {
            commit('setSelectedSurveyIndex', index);
        },

        updateSearchNewSurvey({ commit }, search) {
            commit('setSearchNewSurvey', search);
        },

        getAnswerSetData({ commit, dispatch, state }, answerSetID) {
            state.bWaitCursor = true;
            console.log('En getAnswerSetData...');
            axios
                .get('/setRespuestas/getInfoRespuestas/' + answerSetID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('getAnswerSetData, res = ', res);
                    const answers = res.data.respuestas;
                    const languageAnswers = res.data.respuestasIdiomas;

                    if (answers !== undefined && languageAnswers !== undefined) {
                        commit('setAnswers', answers);
                        commit('setLanguageAnswers', languageAnswers);
                        dispatch('createAnswerSetLanguages');
                    }
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getAnswerSetData, error = ', error);
                    state.bWaitCursor = false;
                });

            // setTimeout(() => {
            //     var answers = [
            //         {
            //             valoressetrespuestasid: 1,
            //             setrespuestasid: 1,
            //             valor: 0
            //         },
            //         {
            //             valoressetrespuestasid: 2,
            //             setrespuestasid: 1,
            //             valor: 1
            //         },
            //         {
            //             valoressetrespuestasid: 3,
            //             setrespuestasid: 1,
            //             valor: 2
            //         }
            //     ];

            //     var languageAnswers = [
            //         {
            //             valoressetrespuestasid: 1,
            //             idiomaid: 1,
            //             respuesta: 'Totalmente en desacuerdo'
            //         },
            //         {
            //             valoressetrespuestasid: 1,
            //             idiomaid: 2,
            //             respuesta: 'Totally disagree'
            //         },
            //         {
            //             valoressetrespuestasid: 2,
            //             idiomaid: 1,
            //             respuesta: 'Parcialmente de acuerdo'
            //         },
            //         {
            //             valoressetrespuestasid: 2,
            //             idiomaid: 2,
            //             respuesta: 'Partially agree'
            //         },
            //         {
            //             valoressetrespuestasid: 3,
            //             idiomaid: 1,
            //             respuesta: 'Totalmente de acuerdo'
            //         },
            //         {
            //             valoressetrespuestasid: 3,
            //             idiomaid: 2,
            //             respuesta: 'Totally agree'
            //         }
            //     ];
            //     state.bWaitCursor = false;
            //     commit('setAnswers', answers);
            //     commit('setLanguageAnswers', languageAnswers);
            //     dispatch('createAnswerSetLanguages');
            //     console.log("Fin de TimeOut de prueba.");
            // }, 1)
        },

        createAnswerSetLanguages({ commit, state }) {
            state.bWaitCursor = true;
            var answerTable = [];
            var answerSetLanguages = []; //Arreglo con todos los idiomas del set de respuestas.

            var i;
            for (i = 0; i < state.answers.length; i++) {
                const answer = {
                    num: i + 1, //Número de respuesta
                    valoressetrespuestasid: state.answers[i].valoressetrespuestasid,
                    valor: state.answers[i].valor
                };
                var j;
                for (j = 0; j < state.languageAnswers.length; j++) {
                    if (
                        state.languageAnswers[j].valoressetrespuestasid ===
                        state.answers[i].valoressetrespuestasid
                    ) {
                        var k;

                        for (k = 0; k < state.languages.length; k++) {
                            if (state.languages[k].idiomaid === state.languageAnswers[j].idiomaid) {
                                var l;
                                var bLanguageFound = false;
                                for (l = 0; l < answerSetLanguages.length; l++) {
                                    if (
                                        answerSetLanguages[l].languageID ===
                                        state.languages[k].idiomaid
                                    ) {
                                        bLanguageFound = true;
                                        break;
                                    }
                                }
                                if (!bLanguageFound) {
                                    const lang = {
                                        languageID: state.languages[k].idiomaid,
                                        language: state.languages[k].idioma
                                    };
                                    answerSetLanguages.push(lang);
                                }
                                const idiomaid = state.languageAnswers[j].idiomaid;
                                answer[idiomaid] = state.languageAnswers[j].respuesta;
                                break;
                            }
                        }
                    }
                }
                //console.log("answer to push: ", answer);
                answerTable.push(answer);
            }

            console.log('AnswerTable: ', answerTable);
            commit('setAnswerTable', answerTable);

            //Genera el header para la tabla de respuestas:

            var answerHeader = [
                {
                    text: 'Número',
                    value: 'num',
                    sortable: false,
                    width: '5%',
                    align: 'center',
                    divider: true
                },
                {
                    text: 'Valor',
                    value: 'valor',
                    sortable: false,
                    width: '5%',
                    align: 'center',
                    divider: true
                }
            ];

            const columnWidth = 90 / answerSetLanguages.length;

            for (i = 0; i < answerSetLanguages.length; i++) {
                const column = {
                    text: answerSetLanguages[i].language,
                    value: answerSetLanguages[i].languageID.toString(),
                    sortable: false,
                    width: columnWidth + '%',
                    divider: true
                };
                answerHeader.push(column);
            }
            //console.log("answerHeader = ", answerHeader);
            var languagesAnswerSet = []; //arreglo con todos los idiomas, con una bandera especificando si cada idioma está seleccionado para el set de respuestas.
            for (i = 0; i < state.languages.length; i++) {
                const lang = {
                    languageID: state.languages[i].idiomaid,
                    language: state.languages[i].idioma,
                    selected: false
                };

                var j;
                for (j = 0; j < answerSetLanguages.length; j++) {
                    if (answerSetLanguages[j].languageID === state.languages[i].idiomaid) {
                        lang.selected = true;
                        break;
                    }
                }
                languagesAnswerSet.push(lang);
            }

            //console.log("languagesAnswerSet = ", languagesAnswerSet);

            commit('setLanguagesAnswerSet', languagesAnswerSet);
            commit('setAnswerTableHeader', answerHeader);

            state.bWaitCursor = false;
        },

        updateAnswerSet({ state }, answerSetToEdit) {
            if (!state.idToken) {
                return;
            }
            console.log('AnswerSet to update: ', answerSetToEdit);

            state.bWaitCursor = true;
            state.bSearchNewAnswerSet = true;
            state.newAnswerSetName = answerSetToEdit.nombre;

            axios
                .post('/setRespuestas/updateSetRespuestas/' + state.idToken, answerSetToEdit)
                .then(res => {
                    state.bWaitCursor = false;
                    state.bSearchNewAnswerSet = true;
                    state.newAnswerSetName = answerSetToEdit.nombre;

                    //Se asegura de que los valores de las preguntas sean enteros y no strings:
                    var i;
                    for (i = 0; i < state.answers.length; i++) {
                        state.answers[i].valor = parseInt(state.answers[i].valor);
                    }

                    //Se crea el objeto con los dos arreglos a pasar en el post:
                    var answerInfo = {
                        respuestas: state.answers,
                        respuestasIdiomas: state.languageAnswers
                    };

                    console.log('answerInfo = ', answerInfo);

                    axios
                        .post('/setRespuestas/updateInfoSetRespuestas/' + state.idToken, answerInfo)
                        .then(res => {
                            state.bWaitCursor = false;
                            console.log('Respuestas saved, res = ', res);
                        })
                        .catch(error => {
                            state.bWaitCursor = false;
                        });
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },
        saveNewAnswerSet({ state }, newAnswerSet) {
            if (!state.idToken) {
                return;
            }
            console.log('AnswerSet to save: ', newAnswerSet);

            state.bWaitCursor = true;
            state.bSearchNewAnswerSet = true;
            state.newAnswerSetName = newAnswerSet.nombre;

            axios
                .post('/setRespuestas/saveSetRespuestas/' + state.idToken, newAnswerSet)
                .then(res => {
                    console.log('New AnswerSet saved, res = ', res);

                    const newAnswerSetID = res.data.setrespuestasid;

                    var newAnswers = [];
                    var i;
                    for (i = 0; i < state.answers.length; i++) {
                        var answer = {
                            setrespuestasid: newAnswerSetID,
                            //Se asegura de pasar un entero y no un string:
                            valor: parseInt(state.answers[i].valor)
                        };
                        newAnswers.push(answer);
                    }

                    var newLanguageAnswers = [];
                    for (i = 0; i < state.languageAnswers.length; i++) {
                        var languageAnswer = {
                            idiomaid: state.languageAnswers[i].idiomaid,
                            respuesta: state.languageAnswers[i].respuesta
                        };
                        newLanguageAnswers.push(languageAnswer);
                    }

                    var answerInfo = {
                        respuestas: newAnswers,
                        respuestasIdiomas: newLanguageAnswers
                    };

                    console.log('answerInfo = ', answerInfo);

                    axios
                        .post('/setRespuestas/saveInfoSetRespuestas/' + state.idToken, answerInfo)
                        .then(res => {
                            state.bWaitCursor = false;
                            console.log('Respuestas saved, res = ', res);
                        })
                        .catch(error => {
                            state.bWaitCursor = false;
                            console.log(error);
                        });
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        updateSelectedLanguageIndex({ commit }, index) {
            commit('updateSelectedLanguageIndex', index);
        },
        saveNewLanguage({ dispatch, state }, newLanguage) {
            if (!state.idToken) {
                return;
            }
            //console.log("Language to save: ", newLanguage);

            state.bWaitCursor = true;
            state.bSearchNewLanguage = true;
            state.newLanguageName = newLanguage.idioma;

            axios
                .post('/idiomas/' + state.idToken, newLanguage)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los idiomas:
                    dispatch('fetchLanguages');
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewLanguage = false;
                });
        },
        updateLanguage({ dispatch, state }, language) {
            if (!state.idToken) {
                return;
            }
            console.log('Language to save: ', language);

            state.bWaitCursor = true;
            state.bSearchNewLanguage = true;
            state.newLanguageName = language.idioma;

            axios
                .post('/idiomas/' + language.idiomaid + '/' + state.idToken, language)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los idiomas:
                    dispatch('fetchLanguages');
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                    state.bSearchNewLanguage = false;
                });
        },
        deleteLanguage({ dispatch, state }, idiomaID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/idiomas/deleteIdioma/' + idiomaID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los idiomas:
                    dispatch('fetchLanguages');
                })
                .catch(error => {
                    console.log(error);
                });
        },

        updateLanguagesAnswerSet({ commit }, languagesAnswerSet) {
            commit('setLanguagesAnswerSet', languagesAnswerSet);
        },

        updateSelectedAnswerSetIndex({ commit }, index) {
            commit('setSelectedAnswerSetIndex', index);
        },

        updateAnswers({ commit }, answers) {
            commit('setAnswers', answers);
        },

        updateLanguageAnswers({ commit }, languageAnswers) {
            commit('setLanguageAnswers', languageAnswers);
        },

        fetchUsers({ commit, state }) {
            //En esta función se obtienen los usuarios administradores, no los de las encuestas.
            state.bWaitCursor = true;

            axios
                .get('/usuarios/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de fetchUsuarios: ', res);
                    const users = res.data;
                    commit('setUsers', users);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchAdministrators({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/usuarios/getAdmin/' + state.idToken, { crossDomain: true })
                .then(res => {
                    const data = res.data;
                    console.log('res de administradores: ', data);
                    const users = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const user = data[i];
                        users.push(user);
                    }
                    state.bWaitCursor = false;
                    console.log('Administrators: ', users);
                    commit('setAdministrators', users);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        setDuplicatedUserError({ commit }, payload) {
            commit('setDuplicatedUserError', payload);
        },

        saveNewUser({ dispatch, state }, newUser) {
            //Checa que no haya un usuario registado con el mismo correo:

            state.bWaitCursor = true;
            console.log('email: ', newUser.email);

            axios
                .get('/usuarios/getByEmail/' + newUser.email + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    state.bWaitCursor = false;
                    const data = res.data;
                    console.log('New User, res = ', data);
                    if (data.usuarioid === 0) {
                        //No se encontró un usuario con ese correo...
                        //console.log("Todo bien, podemos registrar usuario...");
                        dispatch('storeNewUser', newUser);
                    } //Ya hay un usuario con ese correo...
                    else {
                        dispatch('setDuplicatedUserError', true);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        storeNewUser({ dispatch, state }, newUser) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewUser = true;
            state.newUserEmail = newUser.email;

            console.log('User to save: ', newUser);

            axios
                .post('/usuarios/' + state.idToken, newUser)
                .then(res => {
                    state.bWaitCursor = false;
                    //console.log("res de CreateUser: ", res);
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewUser = false;
                });
        },

        editUser({ dispatch, state }, user) {
            state.bWaitCursor = true;

            console.log('user = ', user);

            //Si el objeto user trae password quiere decir que hay que editar el password:
            console.log('user.password = ', user.password);
            if (user.password !== '') {
                //Cambia el password en la tabla de autenticación:
                console.log('Cambiando Password...');

                //Se crea un objeto con el ID y el password:
                const userPasswd = {
                    usuariosid: user.usuarioid,
                    password: user.password
                };

                axios
                    .post(
                        '/usuarios/updateUserPassword/' +
                            userPasswd.usuariosid +
                            '/' +
                            state.idToken,
                        userPasswd
                    )
                    .then(res => {
                        state.bWaitCursor = false;
                    })
                    .catch(error => {
                        console.log(error);
                        state.bWaitCursor = false;
                    });
            }

            //Edición de los datos del usuario:
            const userData = {
                usuarioid: user.usuarioid,
                activo: user.activo,
                email: user.email,
                nombre: user.nombre,
                appaterno: user.appaterno,
                apmaterno: user.apmaterno,
                empresaid: user.empresaid,
                tipoid: user.tipoid,
                cuestionarioid: user.cuestionarioid,
                numLicencias: user.numLicencias
            };
            console.log('user to save: ', userData);
            state.bWaitCursor = true;
            axios
                .post('/usuarios/' + user.usuarioid + '/' + state.idToken, userData)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res de Edición de Usuario: ', res);
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewUser = false;
                });
        },
        updateSelectedUserIndex({ commit }, index) {
            commit('updateSelectedUserIndex', index);
        },

        deleteUser({ dispatch, state }, userID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/usuarios/deleteUser/' + userID + '/0/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                });
        },

        updateReportProcessed({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setReportProcessed', payload);
        },

        updateReportWarning({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setReportWarning', payload);
        },

        updatePdfPath({ commit, state }, strPath) {
            if (!state.idToken) {
                return;
            }
            commit('setPdfPath', strPath);
        },
        processReport({ state }, reportInfo) {
            state.bWaitCursor = true;

            axios
                .get('/reportGenerator/getReporte/' + reportInfo.surveyID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('ProcessReport res = ', res);

                    if (res.data !== 0) {
                        state.iReportWarning = 0;
                        state.pdfPath = 'https://www.retroalimentame.com.mx/' + res.data;
                    } else if (res.data === 0) {
                        //Hubo algún error desconocido al tratar de procesar el reporte...
                        console.log('res.data = 0');
                        state.iReportWarning = 1;
                        state.pdfPath = '';
                    }
                    state.bReportProcessed = true;
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        }
    },

    getters: {
        version: state => {
            return state.version;
        },
        appTitle: state => {
            return state.appTitle;
        },
        mainLogo: state => {
            return state.mainLogo;
        },
        mainLogoAppBar: state => {
            return state.mainLogoAppBar;
        },
        inteligenciaEjecutivaLogo: state => {
            return state.inteligenciaEjecutivaLogo;
        },
        inteligenciaEjecutivaLogo1: state => {
            return state.inteligenciaEjecutivaLogo1;
        },
        mainBackgroundImg: state => {
            return state.mainBackgroundImg;
        },
        waitCursor: state => {
            return state.bWaitCursor;
        },
        failedLogin: state => {
            return state.bFailedLogin;
        },
        inactiveUser: state => {
            return state.bInactiveUser;
        },
        isAuthenticated(state) {
            return state.idToken !== null && state.idToken !== undefined;
        },
        duplicatedUserError(state) {
            return state.bDuplicatedUserError;
        },
        user(state) {
            return state.user;
        },
        userName(state) {
            return state.userName;
        },
        loggedUserID(state) {
            return state.userID;
        },

        userType(state) {
            return state.user.tipoid;
        },

        isAdmin(state) {
            return state.bAdmin;
            //return false;
        },

        userTypes(state) {
            return state.userTypes;
        },
        selectedUserTypeIndex: state => {
            return state.selectedUserTypeIndex;
        },
        questionnaires(state) {
            return state.questionnaires;
        },
        selectedQuestionnaireIndex: state => {
            return state.selectedQuestionnaireIndex;
        },
        searchNewQuestionnaire: state => {
            return state.bSearchNewQuestionnaire;
        },
        newQuestionnaireID: state => {
            return state.newQuestionnaireID;
        },
        questionnaireLanguages(state) {
            return state.questionnaireLanguages;
        },
        questionnaireIntros(state) {
            return state.questionnaireIntros;
        },
        questionnaireIntroTable(state) {
            return state.questionnaireIntroTable;
        },
        questionnaireSituations(state) {
            return state.questionnaireSituations;
        },
        questionnaireSituationsLang(state) {
            return state.questionnaireSituationsLang;
        },
        questionnaireAutoevaluations(state) {
            return state.questionnaireAutoevaluations;
        },
        questionnaireAutoevaluationsLang(state) {
            return state.questionnaireAutoevaluationsLang;
        },
        questionnaireAnswers(state) {
            return state.questionnaireAnswers;
        },
        questionnaireAnswersLang(state) {
            return state.questionnaireAnswersLang;
        },
        questionnaireSituationTable(state) {
            return state.questionnaireSituationTable;
        },
        questionnaireAutoevaluationTable(state) {
            return state.questionnaireAutoevaluationTable;
        },
        questionnaireAnswerHeader(state) {
            return state.questionnaireAnswerHeader;
        },
        questionnaireAnswerTable(state) {
            return state.questionnaireAnswerTable;
        },
        questionnaireTablesHeader(state) {
            return state.questionnaireTablesHeader;
        },
        questionnaireNotDeletedWarning(state) {
            return state.bQuestionnaireNotDeletedWarning;
        },
        serverResponse(state) {
            return state.bServerResponse;
        },
        surveys(state) {
            return state.surveys;
        },
        survey(state) {
            return state.survey;
        },
        surveyLoaded(state) {
            return state.bSurveyLoaded;
        },
        loadingSurvey(state) {
            return state.bLoadingSurvey;
        },
        questionnaireLoaded(state) {
            return state.bQuestionnaireLoaded;
        },
        loadingQuestionnaire(state) {
            return state.bLoadingQuestionnaire;
        },
        selectedSurveyIndex: state => {
            return state.selectedSurveyIndex;
        },
        searchNewSurvey: state => {
            return state.bSearchNewSurvey;
        },
        selectedAnswerSetIndex: state => {
            return state.selectedAnswerSetIndex;
        },
        answers(state) {
            return state.answers;
        },
        languageAnswers(state) {
            return state.languageAnswers;
        },
        answerTable(state) {
            return state.answerTable;
        },
        answerTableHeader(state) {
            return state.answerTableHeader;
        },
        languagesAnswerSet(state) {
            return state.languagesAnswerSet;
        },
        languages: state => {
            return state.languages;
        },
        selectedLanguageIndex: state => {
            return state.selectedLanguageIndex;
        },
        genders: state => {
            return state.genders;
        },
        organizationalLevels: state => {
            return state.organizationalLevels;
        },
        ageRanges: state => {
            return state.ageRanges;
        },
        users(state) {
            return state.users;
        },
        administrators(state) {
            return state.administrators;
        },
        selectedUserIndex: state => {
            return state.selectedUserIndex;
        },

        selectedPrimaryIndex: state => {
            return state.selectedPrimaryIndex;
        },
        selectedSpecializedIndex: state => {
            return state.selectedSpecializedIndex;
        },

        selectedPrimaryValIndex: state => {
            return state.selectedPrimaryValIndex;
        },
        selectedSpecializedValIndex: state => {
            return state.selectedSpecializedValIndex;
        },

        roles(state) {
            return state.roles;
        },
        rolesExt(state) {
            return state.rolesExt;
        },
        userRoles(state) {
            return state.userRoles;
        },
        selectedRoleIndex: state => {
            return state.selectedRoleIndex;
        },
        userSurveys: state => {
            return state.userSurveys;
        },
        userSurvey: state => {
            return state.userSurvey;
        },
        userSurveyLangID: state => {
            return state.userSurveyLangID;
        },
        userSurveyData: state => {
            return state.userSurveyData;
        },
        surveyResults: state => {
            return state.surveyResults;
        },
        reportProcessed: state => {
            return state.bReportProcessed;
        },
        reportWarning: state => {
            return state.iReportWarning;
        },
        pdfPath: state => {
            return state.pdfPath;
        },
        errorNoLang: state => {
            return state.bErrorNoLang;
        },
        surveyResultsError: state => {
            return state.bSurveyResultsError;
        }
    }
});
